import { Component, OnInit } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { MainFacade } from '../../../main.facade';
import { FileFolder, IFile, IFileInfo } from '../../../models/file-info';
import { FormBuilder, Validators } from '@angular/forms';
import { RequestFactory } from '../../../models/request.factory';
import { SubmissionStateService } from '../../../../services/submission-state.service';
import { ProcessComponentBase } from '../process.component.base';

@Component({
  selector: 'kidney-classifier',
  templateUrl: './kidney-classifier.component.html',
  styleUrls: ['./kidney-classifier.component.scss'],
})
export class KidneyClassifierComponent extends ProcessComponentBase implements OnInit {

  public parentFolderPath: string | undefined = undefined;

  public imageDirectories: IFileInfo[] = [];

  public models: string[] = [
    'Kidney Classifier/Models/LinkNet_KidneyAge.jld2'
  ];

  constructor(mainFacade: MainFacade,
              private fb: FormBuilder,
							submissionState: SubmissionStateService) {
								
								
		super('Kidney Classifier', submissionState, mainFacade);						
	}

  ngOnInit(): void {
    this.configForm();
    this.mainFacade.getSelectedNode$().subscribe({
      next: (node) => {
        if (node == undefined || node.data == undefined) {
          this.bucket = undefined;
        } else {
          this.setFileDropdownData(node);
        }
      },
      error: (err) => {
        console.error(`Error with node selection: ${err}`);
      },
    });
    this.mainFacade.getValidationMessage$().subscribe({
      next: (message) => {
        this.validationMessage = message;
      }
    });
  }

  setFileDropdownData(node: TreeNode<IFileInfo>) {
    this.imageDirectories = []
    if (node) {
      const selectedFile: IFileInfo | undefined = node.data;
      this.bucket = selectedFile?.project.bucket;
      if (selectedFile) {
        if (selectedFile instanceof FileFolder) {
          this.setChildrenFromParent(node);
        } else {
          this.setChildrenFromParent(node.parent);
        }
      }
    }
  }

  setChildrenFromParent(node: TreeNode<IFileInfo> | undefined) {
    if (node && node.children) {
      node.children.forEach(child => {
        if (child.data) {
          this.imageDirectories.push(child.data);
        }
      });
    }
  }


  configForm() {
    this.form = this.fb.group({
      imageDirectory: [null, Validators.required],
      modelFile: [this.models[0], Validators.required],
      tissueMaskPath: ['TISSUE_MASKS/', Validators.required],
      damageScorePath: ['DAMAGE_SCORE_CSVS/', Validators.required],
      heatmapPath: ['HEAT_MAPS/', Validators.required],
      editTissueMask: [false],
      editDamageScore: [false],
      editHeatmap: [false]
    });
    this.persistForm();
  }

  onSubmit() {
    super.submit(this.buildRequest());
  }

  onCreateRule() {
    super.createRule(this.buildRequest());
  }

  private buildRequest() {
    const request = this.form.value;
    const bucket = request.imageDirectory.project.bucket;
    const parentPath = this.buildPath(request.imageDirectory);
    const kidneyClassifierRequest = RequestFactory.getKidneyClassifierRequestFromForm(request, bucket, parentPath);
    kidneyClassifierRequest.bucket_name = this.bucket;

    return kidneyClassifierRequest;
  }

  buildPath(file: IFile): string {
    const index = file.relPath.indexOf(file.name);
    return file.relPath.substring(0, index);
  }
}